import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const AgencyNameContainer = styled(Box).attrs({
  align: 'center',
  backgroundColor: 'foreground',
  borderRadius: 4,
  flow: 10,
  height: 57,
  horizontal: true,
  padding: 10,
})``;

export const FetchErrorContainer = styled(AgencyNameContainer).attrs({
  justify: 'space-between',
})``;

export const ErrorText = styled(Text).attrs({
  size: 'small',
})`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;
